import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import infoIcon from '../../../../assets/redesign_icons/info-icon.svg';
import {
  LeftSide, LuceInfoModalStyles, ModalBody, ModalContent, ModalHeader, RightSide, TextContainer, TitleBox,
} from './LuceInfoModal.styles';

function LuceInfoModal({
  setShowModal, quotation,
}) {
  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <LuceInfoModalStyles>
      <ModalBody>
        <ModalHeader>
          <LeftSide>
            <FontAwesomeIcon fontSize={34} icon={faTimes} cursor="pointer" onClick={() => closeModal()} />
            <TextContainer>
              <TitleBox>
                <img src={infoIcon} alt="" />
                <h3>Informazione</h3>
              </TitleBox>
              <p>
                Qui puoi controllare le informazioni su questa offerta.
              </p>
            </TextContainer>
          </LeftSide>
          <RightSide />
        </ModalHeader>
        <ModalContent>
          <>
            <table className="custom-table-compact">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Premio</th>
                </tr>
              </thead>
              <tbody>
                <tr className="custom-table-row-compact">
                  <td>Commercializzazione</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.commercializzazione).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>Discount Iva</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.discount_iva).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>Discount No Iva</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.discount_no_iva).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>Dispacciamento</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.dispacciamento).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>Imposte</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.imposte).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>Iva</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.iva).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>Materia_energia</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.materia_energia).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>Oneri Sistema</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.oneri_sistema).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>Transporto Gestione</td>
                  <td>
                    {' '}
                    {Number(quotation.fees.trasporto_gestione).toLocaleString(
                      'it-IT',
                      { minimumFractionDigits: 2 },
                    )}
                    €
                  </td>
                </tr>
                <tr className="custom-table-row-compact">
                  <td>
                    <b>Totale</b>
                  </td>
                  <td>
                    <b>
                      {Number(quotation.fees.total).toLocaleString(
                        'it-IT',
                        { minimumFractionDigits: 2 },
                      )}
                      €
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          </>
          <div className="card-extra-information">
            <h3>Informazioni</h3>
            <p>
              <b>Descrizione:</b>
              {' '}
              {quotation?.dettaglio?.DESCRIZIONE ?? 'Nessuna descrizione disponibile.'}
            </p>
            <br />
            <p>
              <b>Garanzie:</b>
              {' '}
              {quotation?.dettaglio?.GARANZIE ?? 'Nessuna durata disponibile.'}
            </p>
          </div>
        </ModalContent>
      </ModalBody>
    </LuceInfoModalStyles>
  );
}

export default LuceInfoModal;
